export const ApiUrl = process.env.REACT_APP_CE_API_ENDPOINT || 'http://localhost:18080';
// export const ApiUrl = 'https://dev-cloud-extension001.tribawl.com';
